import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { vacancyDetailsRoutingoModule } from './vacancy-details-routing.module';
import { VacancyDetailsComponent } from './vacancy-details.component';
@NgModule({
  imports: [
    vacancyDetailsRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [VacancyDetailsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class vacancyModule { }
